import React from 'react';
import { makeClassName } from '@siteless/util';

const BellIcon = ({
  className,
  ...rest
}: {
  className?: string;
  [x: string]: any;
}) => (
  <svg
    className={makeClassName('BellIcon', className)}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    fill="none"
    {...rest}
  >
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" fill="none" />
    <path d="M13.73 21a2 2 0 0 1-3.46 0" fill="none" />
  </svg>
);

export default BellIcon;
